import { useEffect, useState } from "react";
import { Input } from "./kd";
import { maskDateDE } from "../lib/format";

const toDe = (iso: string) => (iso && /^\d{4}-\d{2}-\d{2}$/.test(iso) ? iso.split("-").reverse().join(".") : "");

function parse(v: string): string | null {
  const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(v.trim());
  if (!m) return null;
  const d = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
  if (d.getDate() !== Number(m[1]) || d.getMonth() !== Number(m[2]) - 1) return null;
  return `${m[3]}-${m[2]}-${m[1]}`;
}

/** Datumseingabe im Format TT.MM.JJJJ; value/onChange arbeiten mit ISO (JJJJ-MM-TT). */
export function DateInputDE({ value, onChange, ...rest }: { value: string; onChange: (iso: string) => void; [k: string]: any }) {
  const [text, setText] = useState(toDe(value));
  useEffect(() => { if (parse(text) !== value) setText(toDe(value)); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  const invalid = text !== "" && parse(text) === null;
  return (
    <Input
      {...rest}
      inputMode="numeric"
      placeholder="TT.MM.JJJJ"
      maxLength={10}
      value={text}
      aria-invalid={invalid}
      onChange={(e) => {
        const t = maskDateDE(e.target.value, text);
        setText(t);
        onChange(t === "" ? "" : parse(t) || "");
      }}
    />
  );
}

export function TimeInputDE({ value, onChange, ...rest }: { value: string; onChange: (v: string) => void; [k: string]: any }) {
  const ok = /^([01]\d|2[0-3]):[0-5]\d$/.test(value);
  return <Input {...rest} inputMode="numeric" placeholder="HH:MM" maxLength={5} value={value} aria-invalid={value !== "" && !ok} onChange={(e) => onChange(e.target.value)} />;
}
